module.exports = __webpack_public_path__ + "static/img/b4_body.a13231f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b4_body.png
// module id = qF6v
// module chunks = 1